// Route helpers shared by the /news and /news/$type routes and `NewsListing`.
// (Kept out of news/types.ts, which must stay dependency-free: `newsHead`
// needs seo.ts.)
import { NEWS_TYPES } from './types'
import type { NewsType } from './types'
import { pageMeta } from '../site/seo'

// Tabs match the live Webflow tabs. The tab is in the path (/news,
// /news/blog) so each tab's first page is prerendered; pagination is the
// `page` query param (/news/blog?page=2). The old query URLs
// (/news?type=blog) redirect in the root route, the old hash URLs
// (/news#blog) in `NewsListing`.
export const NEWS_TAB_LABELS: Record<NewsType, string> = {
  all: 'All',
  'top-press': 'Top Press',
  blog: 'Blog',
  'press-releases': 'Press Releases',
}

export const TABS = NEWS_TYPES.map((id) => ({
  id,
  label: NEWS_TAB_LABELS[id],
}))

export const tabPath = (type: NewsType) =>
  type === 'all'
    ? ({ to: '/news' } as const)
    : ({ to: '/news/$type', params: { type } } as const)

export const validateNewsSearch = (
  search: Record<string, unknown>,
): { page?: number; q?: string } => ({
  page: Number(search.page) > 1 ? Math.floor(Number(search.page)) : undefined,
  q:
    typeof search.q === 'string' && search.q.trim()
      ? search.q.trim()
      : undefined,
})

export const newsHead = (title: string) =>
  pageMeta({
    title,
    description:
      'Breaking news and publications from Direct Action Everywhere.',
  })
